import Client from './KomodoClient';

// komodo DownloadReportController (api/download-report): report exports generated out of band and
// stored on S3; `downloadUrl` is already absolute (AwsSetting.DomainUrl + key).
const list = (deptCode, downloadType) =>
	Client.post('/api/download-report/query-list', {
		deptCode,
		downloadType: downloadType || null,
	});
// DownloadReportDTO { downloadType, deptCode, requestID, requestJson, queryStartDate, queryEndDate }
const create = (dto) => Client.post('/api/download-report', dto);

export default { list, create };
